// ASC Alignment — PSD §9.7 (F9.7). Report screen accordion.

import type { ValuationResult } from '@backsolve/shared-types';
import { buildAscAnnex } from '../../report/ascAlignment';

interface AscAlignmentProps {
  result: ValuationResult;
}

export function AscAlignment({ result }: AscAlignmentProps) {
  const annex = buildAscAnnex(result);

  return (
    <div className="asc-alignment">
      <h4>ASC 718 — Stock Compensation</h4>
      <table className="data-table">
        <tbody>
          <tr>
            <td>
              <strong>Standard</strong>
            </td>
            <td>{annex.asc718.standard}</td>
          </tr>
          <tr>
            <td>
              <strong>Classification</strong>
            </td>
            <td>{annex.asc718.classification}</td>
          </tr>
          <tr>
            <td>
              <strong>Grant-Date Fair Value</strong>
            </td>
            <td>${annex.asc718.grantDateFairValue.toFixed(4)}/share</td>
          </tr>
          <tr>
            <td>
              <strong>Measurement Approach</strong>
            </td>
            <td style={{ fontSize: 'var(--font-size-2)' }}>{annex.asc718.measurementApproach}</td>
          </tr>
        </tbody>
      </table>

      <p className="field-hint mt-3">
        {annex.asc718.disclosure}
      </p>

      <h4 className="mt-4">ASC 820 — Fair Value Hierarchy</h4>
      <p>
        <span className={`badge badge-${annex.asc820.level === 'Level 3' ? 'warning' : 'info'}`}>
          {annex.asc820.level}
        </span>
      </p>
      <table className="data-table mt-3">
        <thead>
          <tr>
            <th>Input</th>
            <th>Value</th>
            <th>Level</th>
          </tr>
        </thead>
        <tbody>
          {annex.asc820.inputs.map((inp) => (
            <tr key={inp.name}>
              <td>{inp.name}</td>
              <td>{inp.value}</td>
              <td>Level {inp.level}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <p className="field-hint mt-3">
        {annex.asc820.disclosure}
      </p>
    </div>
  );
}
